import { createAction } from 'redux-actions';
import { EDIT_INLINE_TEMPLATE } from '@spinnaker/kayenta';


export const updateDynatraceInlineTemplate = createAction<{ value: string }>(EDIT_INLINE_TEMPLATE);
export const updateCloudwatchInlineTemplate = createAction<{ value: string }>(EDIT_INLINE_TEMPLATE);
